import { Link } from 'react-router-dom';  

const Sonido = () => {  
    return (  
        <>  
            <div className='h-full pb-14 md:pb-24 w-full md:w-3/4 px-4 md:px-0'>  
                <div className='text-center md:text-left py-12 sm:w-full h-auto transformacion-container'>  
                    <h1 className="text-3xl lg:text-6xl md:mb-4 transformacion-title text-purple-300" style={{ lineHeight: '1.2' }}>  
                        El sonido <br /> de una nueva aventura  
                    </h1>  
                </div>  

                <div className='w-full sm:w-3/4 md:w-2/4'>
                    <Link   
                        to="/login"   
                        className="px-6 sm:px-8 py-2 sm:py-3 text-white font-semibold rounded-full bg-gradient-to-r from-pink-500 to-indigo-600 shadow-md hover:opacity-90 inline-block">  
                        INICIAR SESIÓN  
                    </Link>  
                </div>  
            </div>  
        </>  
    );  
}  

export default Sonido;